import React, { useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import axios from "axios";

import AppContext from '../../../../context/AppContext';

import AddCustomerModal from '../../../../components/Admin/CustomerManagement/AddCustomerModal/AddCustomerModal';
import ActionMenu from '../../../../components/Admin/CustomerManagement/ActionMenu/ActionMenu';
import ViewProfileModal from '../../../../components/Admin/CustomerManagement/ViewProfileModal/ViewProfileModal';
import OrderHistoryModal from '../../../../components/Admin/CustomerManagement/OrderHistoryModal/OrderHistoryModal';

import '../../../../assests/css/admin/CustomerManagement/CustomerManagement.css';

const CustomerManagement = () => {

  const { baseUrl } = useContext(AppContext);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showActionMenu, setShowActionMenu] = useState(null);
  const [actionMenuPosition, setActionMenuPosition] = useState(null);
  const [showViewProfile, setShowViewProfile] = useState(null);
  const [showOrderHistory, setShowOrderHistory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [customers, setCustomers] = useState([]);

  // ================= HELPERS =================

  const getStatus = (customer) =>
    customer?.customer?.status ||
    customer?.status ||
    "Inactive";

  // FIXED: calculated_totalspent accessor se aayega
  const getTotalSpent = (customer) =>
    customer?.customer?.calculated_totalspent ??
    customer?.customer?.totalspent ??
    customer?.totalspent ??
    0;

  // FIXED: lastorder accessor se aayega
  const getLastOrder = (customer) =>
    customer?.customer?.lastorder ||
    customer?.lastorder ||
    null;

  // ================= FETCH =================

  const getAllCustomers = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/admin/customers/getAllCustomers`
      );
      console.log("CUSTOMERS:", response.data);
      console.log("FIRST:", response.data.data?.[0]);
      setCustomers(response.data.data || []);
    } catch (error) {
      console.log(error.response?.data || error.message);
      Swal.fire("Error", "Failed to load customers", "error");
    }
  };

  useEffect(() => {
    if (baseUrl) getAllCustomers();
  }, [baseUrl]);

  // ================= ADD =================

    const handleAddCustomer = async (formData) => {
    try {
      const data = new FormData();
      data.append('fullName', formData.fullName);
      data.append('email',    formData.email);
      data.append('phone',    formData.phone);
      data.append('password', formData.password || '');

      await axios.post(`${baseUrl}/admin/customers/addCustomer`, data);

      Swal.fire("Success", "Customer Added Successfully", "success");
      setShowAddModal(false);
      getAllCustomers();
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Failed to add customer", "error");
    }
  };

  // ================= DELETE =================

  const deleteCustomer = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Customer will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete"
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.post(
        `${baseUrl}/admin/customers/deleteCustomer`,
        { id }
      );
      Swal.fire("Deleted", "Customer Deleted Successfully", "success");
      getAllCustomers();
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Delete Failed", "error");
    }
  };
    // ================= SUSPEND / ACTIVATE =================

  const toggleSuspend = async (customer) => {
    const customerRowId = customer.customer?.id;
    if (!customerRowId) {
      Swal.fire("Error", "Customer profile not found", "error");
      return;
    }

    const currentStatus = getStatus(customer);
    const newStatus = currentStatus === 'Suspended' ? 'Active' : 'Suspended';

    try {
      await axios.post(`${baseUrl}/admin/customers/updateCustomer/${customerRowId}`, {
        mlcustomerauth_id: customer.id,
        status:            newStatus,
        totalspent:        getTotalSpent(customer),
      });
      Swal.fire("Success", `Customer ${newStatus.toLowerCase()} successfully`, "success");
      getAllCustomers();
    } catch (error) {
      Swal.fire("Error", "Failed to update status", "error");
    }
  };

  // ================= ACTION HANDLER =================

  const handleAction = (action, customer) => {
    setShowActionMenu(null);

    switch (action) {

      case 'view':
        setShowViewProfile({
          firstname:  customer.firstname || "",
          lastname:   customer.lastname || "",
          email:      customer.email || "",
          phone:      customer.phone || customer.phonenumber || "",
          status:     getStatus(customer),
          totalspent: getTotalSpent(customer),
          lastorder:  getLastOrder(customer)
        });
        break;

      case 'orders':
        setShowOrderHistory({
          id:         customer.customer?.id,  
          firstname:  customer.firstname || "",
          lastname:   customer.lastname || "",
          email:      customer.email || "",
          phone:      customer.phone || customer.phonenumber || "",
          status:     getStatus(customer),
          totalspent: getTotalSpent(customer),
          lastorder:  getLastOrder(customer)
        });
        break;

      case 'delete':
        deleteCustomer(customer.customer?.id || customer.id);
        break;

      // case 'message':
      //   Swal.fire("Info", `Message to ${customer.firstname}`, "info");
      //   break;
      case 'message':
  window.location.href = `mailto:${customer.email}`;
  break;

            case 'suspend':
        toggleSuspend(customer);
        break;
      }
  };

  // ================= FILTER =================

  const filteredCustomers = customers.filter((c) => {
    const search = searchTerm.toLowerCase();

    const matchesSearch =
      (c.firstname || '').toLowerCase().includes(search) ||
      (c.lastname || '').toLowerCase().includes(search) ||
      (c.email || '').toLowerCase().includes(search) ||
      (c.phone || '').includes(searchTerm) ||
      (c.phonenumber || '').includes(searchTerm);

    const matchesStatus =
      statusFilter === 'All' || getStatus(c) === statusFilter;

    return matchesSearch && matchesStatus;
  });

  // ================= FORMAT DATE =================

  const formatDate = (dateStr) => {
    if (!dateStr) return "No Orders Yet";
    return new Date(dateStr).toLocaleDateString('en-PK', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // ================= RENDER =================

  return (
    <div className="customer-management">

      {/* HEADER */}
      <div className="cm-header">
        <div>
          <h1 className="cm-title">Customer Management</h1>
          <p className="cm-subtitle">Manage your customers</p>
        </div>
      </div>

      {/* FILTERS */}
      <div className="cm-filters">
        <input
          type="text"
          className="cm-search-input"
          placeholder="Search customers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select
          className="cm-filter-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option>All</option>
          <option>Active</option>
          <option>Inactive</option>
          <option>Suspended</option>
        </select>
      </div>

      {/* TABLE */}
      <div className="cm-table-container">
        <table className="cm-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Contact</th>
              <th>Status</th>
              <th>Total Spent</th>
              <th>Last Order</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers.length > 0 ? (
              filteredCustomers.map((customer) => (
                <tr key={customer.id}>

                  {/* CUSTOMER */}
                  <td>
                    <div>
                      <b>
                        {customer.firstname || "No Name"}{" "}
                        {customer.lastname || ""}
                      </b>
                      <div>ID: {customer.id}</div>
                    </div>
                  </td>

                  {/* CONTACT */}
                  <td>
                    <div>{customer.email || "No Email"}</div>
                    <div>
                      {customer.phone ||
                        customer.phonenumber ||
                        "No Phone"}
                    </div>
                  </td>

                  {/* STATUS */}
                  <td>
                    <span className={`status ${getStatus(customer).toLowerCase()}`}>
                      {getStatus(customer)}
                    </span>
                  </td>

                  {/* TOTAL SPENT */}
                  <td>Rs. {getTotalSpent(customer)}</td>

                  {/* LAST ORDER */}
                  <td>{formatDate(getLastOrder(customer))}</td>

                  {/* ACTION BUTTON */}
                  <td>
                    <button
                      className="cm-action-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActionMenuPosition({ x: e.clientX, y: e.clientY });
                        setShowActionMenu(customer);
                      }}
                    >
                      ⋯
                    </button>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                  No Customers Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ADD MODAL */}
      <AddCustomerModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onAdd={handleAddCustomer}
      />

      {/* ACTION MENU */}
      <ActionMenu
        isOpen={showActionMenu !== null}
        onClose={() => setShowActionMenu(null)}
        customer={showActionMenu}
        onAction={(action) => handleAction(action, showActionMenu)}
        position={actionMenuPosition}
      />

      {/* VIEW PROFILE */}
      <ViewProfileModal
        isOpen={showViewProfile !== null}
        onClose={() => setShowViewProfile(null)}
        customer={showViewProfile}
      />

      {/* ORDER HISTORY */}
      <OrderHistoryModal
        isOpen={showOrderHistory !== null}
        onClose={() => setShowOrderHistory(null)}
        customer={showOrderHistory}
      />

    </div>
  );
};

export default CustomerManagement;